/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SuitesChooser_team$ref: FragmentReference;
declare export opaque type SuitesChooser_team$fragmentType: SuitesChooser_team$ref;
export type SuitesChooser_team = {|
  +id: string,
  +slug: string,
  +organization: ?{|
    +suites: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +name: string,
          +slug: string,
        |}
      |}>
    |}
  |},
  +permissions: {|
    +teamSuiteCreate: ?{|
      +allowed: boolean
    |}
  |},
  +$refType: SuitesChooser_team$ref,
|};
export type SuitesChooser_team$data = SuitesChooser_team;
export type SuitesChooser_team$key = {
  +$data?: SuitesChooser_team$data,
  +$fragmentRefs: SuitesChooser_team$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "suiteAddSearch"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "teamSelector"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SuitesChooser_team",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            },
            {
              "kind": "Literal",
              "name": "order",
              "value": "NAME"
            },
            {
              "kind": "Variable",
              "name": "search",
              "variableName": "suiteAddSearch"
            },
            {
              "kind": "Variable",
              "name": "team",
              "variableName": "teamSelector"
            }
          ],
          "concreteType": "SuiteConnection",
          "kind": "LinkedField",
          "name": "suites",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SuiteEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Suite",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamPermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "teamSuiteCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ecb61fc4c76b6ecefdb52695e0b46eed';

module.exports = node;
